module.exports = __webpack_public_path__ + "img/whiteClose.4e3bb464.png";